<template>
	<div style="height:100%">
	  <el-table
		  :data="pinnacleInfo"
		  height="100%"
		  class="InverterTable"
		  style="width: 100%;height:100%;">
		  <el-table-column
			prop="name"
			label="名称"
			min-width="150"
		   >
		  </el-table-column>
		  <el-table-column
			prop="total"
			label="总发电量"
			min-width="120"
		   >
		  </el-table-column>
		  <template v-if="range=='day'">
			<el-table-column
				v-for="(item, index) in 24"
				:key="index"
				:prop="index+'点'"
				:label="index+'点'"
				min-width="120"
			  >
			  </el-table-column>
		  </template>
		  <template v-if="range=='month'">
			<el-table-column
				v-for="(item, index) in 31"
				:key="index"
				:prop="item+'日'"
				:label="item+'日'"
				min-width="120"
			  >
			  </el-table-column>
		  </template>
		  <template v-if="range=='year'">
			<el-table-column
				v-for="(item, index) in 12"
				:key="index"
				:prop="item+'月'"
				:label="item+'月'"
				min-width="120"
			  >
			  </el-table-column>
		  </template>
		</el-table>
	</div>
</template>
  
  <script>
  	import {InverterLoop} from "../../../api/power";
	import exportExcel from "../../../util/excel";
	import {
		perDay,
		perMonth, 
		perYear,
		nextDay,
		nextMonth,
		nextYear,
		monthDays,
		dateFormat,
		dayStart,
		dayEnd,
		monthStart,
		monthEnd,
		yearStart,
		yearEnd,
	} from "../../../util/DateUtil";
	import ExcelJS from 'exceljs'
	import FileSaver from 'file-saver'
	export default {
	  props:{
		loops: Array,
		nodes: Array,
		range: String,
		date: Date,
	  },
	  data() {
		return {
			pinnacleInfo:[],
			titles:[],
			timeDate:""
		}
	  },
		async mounted() {
			let _this = this
			_this.initPowerTimeData();
		},
		computed: {
			
			dateName(){
				switch (this.range) {
					case 'day':
						this.timeDate = dateFormat("YY-mm-dd", this.date)
						return "日"
						break;
					case 'week':
						this.timeDate = dateFormat("YY-mm-dd", this.date)
						return "周"
						break;
					case 'month':
						this.timeDate = dateFormat("YY-mm", this.date)
						return "月"
						break;
					case 'year':
						this.timeDate = dateFormat("YY", this.date)
						return "年"
						break;
					default:
						this.timeDate = dateFormat("YY-mm-dd", this.date)
						return "日"
						break;
				}
			},
			selProjectName() {
				return this.$store.getters.selProjectInfo.projectName;
			},
			diagramStatus(){
				return this.$store.state.project.diagramStatus
			},
			propsData() {
				return [
					this.range,
					this.date,
					this.loops,
					this.nodes
				]
			}
		},
		watch: {
			diagramStatus(n){
				if(this.$route.query.uid === 'Energy' ){
					if(n.type === 'excel' && this.pinnacleInfo.length > 0){

						let data = [
							['名称', '总发电量']
						]

						this.titles.forEach(t => {
							data[0].push(t)
						})

						this.pinnacleInfo.forEach(d => {
							data.push([d.name, d.total, ...this.titles.map(t => d[t])])
						})
						// exportExcel(data, '光伏报表', [])
						const workbook = new ExcelJS.Workbook();
						// 创建带有红色标签颜色的工作表
						const sheet = workbook.addWorksheet('Sheet1');

						let letter = ['A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z','AA','AB','AC','AD','AE','AF','AG','AH','AI']
						if(this.range == 'day'){
							letter = letter.filter((e,i)=>i<26)
						}else if(this.range == 'month'){
							letter = letter.filter((e,i)=>i<33)
						}else{
							letter = letter.filter((e,i)=>i<14)
						}

						let sheetName = ["光伏"+this.dateName+"报表",this.selProjectName,'日期：'+this.timeDate]
						let style =  {
							fill: {
								type: 'gradient',
								gradient: 'angle',
								degree: 0,
								stops: [
								{ position: 0, color: { argb: 'd9d9d9' } },//单元格渐变色（左） 
								{ position: 0.5, color: { argb: 'd9d9d9' } },//单元格渐变色（中）
								{ position: 1, color: { argb: 'd9d9d9' } }//单元格渐变色（右）
								]
							},
							font20:{
								name: 'Arial',
								size: 20,
								bold: true
							},
							font12bold:{
								name: 'Arial',
								size: 12,
								bold: true
							},
							font12:{
								name: 'Arial',
								size: 12,
								// bold: true
							},
							alignmentCenter:{ vertical: 'middle', horizontal: 'center' },
							alignmentLeft:{ vertical: 'middle', horizontal: 'left' },
							border:{
								top: {style:'thin'},
								left: {style:'thin'},
								bottom: {style:'thin'},
								right: {style:'thin'}
							}
						}

						//处理一二层
            
						sheet.mergeCells(letter[0]+'1:'+letter[letter.length-1]+'1');
						sheet.getCell(letter[0]+'1').value = sheetName[0]
						sheet.getCell(letter[0]+'1').font = style.font20
						sheet.getCell(letter[0]+'1').alignment = style.alignmentCenter
						
						sheet.mergeCells('A2:B2');
						sheet.mergeCells('C2:'+letter[letter.length-1]+'2');
						sheet.getCell('A2').value = sheetName[1]
						sheet.getCell('C2').value = sheetName[2]
						sheet.getRow(2).font=style.font12bold
						sheet.getRow(2).alignment = style.alignmentLeft
						const rows = sheet.getRows(1, 2);
						rows.map(e=>{e.height = 50 ;return e})

						//表格设置
						let columns = []
						data[0].forEach(item=>{
							columns.push({
								name:item,
							})
						})
						sheet.addTable({
							name: 'MyTable',
							ref: 'A3', // 表格左上角的位置
							headerRow: true,
							totalsRow: false,
							style: {
								theme: 'TableStyleLight1',
								font:{
									name: 'Arial',
									size: 12,
									// bold: true
								},
							},
								//            showRowStripes: true,
							columns:columns,
							rows: data.slice(1),
						})

						//表格头部样式
						sheet.getRow(3).height = 59
						sheet.getRow(3).font=style.font12bold
						
						letter.forEach(item=>{
							sheet.getCell(item+'3').fill = style.fill
							sheet.getCell(item+'3').border = style.border
							sheet.getRow(3).alignment = style.alignmentCenter
						})
						data.slice(1).forEach((item,index)=>{
							sheet.getRow(4+index).height = 38
							sheet.getRow(4+index).font=style.font12
							letter.forEach((e,i)=>{
								if(i<=1){
									sheet.getColumn(e).width = 26
								}else{
									sheet.getColumn(e).width = 14
								}
								sheet.getCell(e+(4+index)).border = style.border
							})
						
							sheet.getRow(4+index).alignment = style.alignmentCenter
						})
						
						

						// workbook.xlsx.writeFile('test.xlsx')
						workbook.xlsx.writeBuffer().then(buffer => {
							FileSaver.saveAs(new Blob([buffer], { type: 'application/octet-stream' }), `${sheetName[0]}.xlsx`);
						})
					}else {
						this.$message.warning("无图表数据！")
					}
				}
			},
			propsData(n) {
				this.initPowerTimeData()
			}
		},
		methods: {
			initPowerTimeData() {
				let data = []
				let promises = [];
				this.loops.forEach((item,index)=>{
					let start = dayStart(new Date(this.date))
					let end = dayEnd(new Date(this.date))
					if(this.range=='month'){
						start = monthStart(new Date(this.date))
						end = monthEnd(new Date(this.date))
					}else if(this.range=='year'){
						start = yearStart(new Date(this.date))
						end = yearEnd(new Date(this.date))
					}
					let obj = {
						start: start,
						end: end,
						loopId:item.loopId,
						range:this.range.toUpperCase()
					}
					promises.push(
						InverterLoop(obj)
					);
				})
				Promise.all(promises).then((res) => {
						let pointsArray = res.map((r) => (r.data ? r.data.data.points : []));
						let xdata = []
					for(let i = 0; i < 24; i++){
						xdata.push(i+'点')
					}
					if(this.range=='month'){
						xdata = []
						for (let i = 0; i < 31; i++) {
							xdata.push(i+1+'日')
						}
					}else if(this.range=='year'){
						xdata = []
						for (let i = 0; i < 12; i++) {
							xdata.push(i+1+'月')
						}
					}
					this.titles = xdata
					pointsArray.forEach((arr,i) => {
						if(arr.length>0){
							let newArry = {};
							let total = 0;
							// for(let item in arr){
							// 	total+=Number(arr[item].toFixed(2))
							// 	newArry[xdata[item]] = arr[item].toFixed(2);
							// }
							for(let item in xdata){
								if(arr[item]!=undefined){
									total+=Number(arr[item].toFixed(2))
									// console.log(arr[item],"arr[item]")
									newArry[xdata[item]] = arr[item].toFixed(2)+" kWh";
								}else{
									newArry[xdata[item]] = "--"
								}
								
							}
							newArry["total"] = total.toFixed(2)+" kWh"
							newArry["name"] = this.loops[i].loopName
							data.push(newArry)
						}
					});
				})
				this.pinnacleInfo = data
			},
		}
	}
  </script>
  
  <style  scoped lang="less">
	.InverterTable /deep/.el-table__body-wrapper{
	  height: calc(100% - 48px);
	}
	.pinnacleTable /deep/.el-table__body-wrapper{
	  height: calc(100% - 96px);
	}
  </style>